import { useEffect, useState } from "react";
import Input from "../Input/Input";
import "./IconSelector.css";
import { DynamicIcon, iconPacks } from "../DynamicIcon/DynamicIcon";
import Modal from "react-modal";

export function IconSelector(props) {
	const [value, setValue] = useState(props.value ?? "");
	const [modalIsOpen, setModalIsOpen] = useState(props.modalIsOpen);
	const [searchIcon, setSearchIcon] = useState("");

	useEffect(() => {
		setModalIsOpen(props.modalIsOpen);
	}, [props.modalIsOpen]);

	useEffect(() => {
		props?.onChange({ target: { value } });
	}, [value])

	function onIconClick(iconName) {
		setValue(iconName);
		setModalIsOpen(false);
	}

	function mountIcons(packName) {
		const components = [];

		const pack = iconPacks[packName];
		const icons = Object.entries(pack);
		for (let i = 0; i < icons.length; i++) {
			const iconEntry = icons[i];
			const Icon = pack[iconEntry[0]];
			if (searchIcon && iconEntry[0].toLowerCase().indexOf(searchIcon.toLowerCase()) === -1) {
				continue;
			}
			components.push(<Icon key={i} onClick={e => onIconClick(iconEntry[0])} />);
		}

		return components;
	}

	return (
		<div className="icon-selector">
			<DynamicIcon iconName={value} size={28} color={'black'} />
			<Input
				name={props.name}
				id={props.id}
				type="text"
				placeholder="Selecione o ícone"
				onClick={e => setModalIsOpen(true)}
				labelText={props.labelText}
				value={value}
				onChange={({ target }) => setValue(target.value)}
				disabled={props.disabled}
				required={props.required}
				readOnly={true}
			/>
			{modalIsOpen && (
				<Modal
					isOpen={modalIsOpen}
					onRequestClose={() => { setModalIsOpen(false) }}
					style={{
						content: {
							top: "50%",
							left: "50%",
							right: "auto",
							bottom: "auto",
							marginRight: "-50%",
							transform: "translate(-50%, -50%)",
							backgroundColor: "var(--containerBackgroundColor)",
							borderRadius: '20px',
						},
					}}
					contentLabel="Modal"
					ariaHideApp={false}
				>
					<div className="modal-content-container modal-upload-backup">
						<h1 className="modal-text">
							Selecione o ícone
						</h1>
						<Input
							name="searchIcon"
							id="searchIcon"
							type="text"
							placeholder="Buscar ícone"
							labelText=""
							value={searchIcon ?? ""}
							onChange={({ target }) => setSearchIcon(target.value)}
							disabled={false}
						/>
						<div className="icons-grid">
							{mountIcons("lu").map(icon => (
								<button type="button" className="icon">
									{icon}
								</button>
							))}
						</div>
					</div>
				</Modal>
			)}
		</div>
	);
}